import type { SelectionMarkerPluginOptions } from '@atlaskit/editor-plugin-selection-marker';

interface Props {
	options: {
		__livePage: boolean;
	};
}

export function selectionMarkerPluginOptions({ options }: Props): SelectionMarkerPluginOptions {
	return {
		hideCursorOnInit: true,
	};
}
